export function hideElement(el, forceHide) {
  if (el.style.display !== 'none') { el.style.display = 'none'; }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/tinySlider/lib/helpers/hideElement.js